import { bootstrapApplication } from '@angular/platform-browser';
import eruda from 'eruda';
import { environment } from '../environments/environment.dev';
import { App } from './app';
import { appConfig } from './app.config';

if (environment.environment === 'development') {
    eruda.init();
}

bootstrapApplication(App, appConfig).catch(err => console.error(err));

